var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"250px","width":"100%"},attrs:{"id":"videoplayer"}}),_c('div',{attrs:{"id":"video_container"}},[_c('v-tree',{attrs:{"data":_vm.courseResourceTreeTrySeeData,"show-line":""},on:{"select":_vm.coursetreeplay}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }